import { assignController, select, selectAll } from '../api/element-manipulation'
import SearchBar from '../components/SearchBar.svelte'

assignController('searchBar', (element) => {
  console.log('### SearchBar')
  const configurationElement = select(element, '[data-hook~="searchBar.configuration"]')
  const configuration = JSON.parse(configurationElement.textContent)
  configurationElement.parentNode.removeChild(configurationElement)

  const svelteApp = new SearchBar({
    target: element,
    props: {
      configuration,
    },
  })

  const controller = {
    svelteApp,
  }

  return controller
})
